import * as React from "react"

const Doorstep = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.12 66.5" {...props}>
    <title>{"parcel-journey-8-doorstep-package-icon-2"}</title>
    <path
      fill="#4ead90"
      d="M41.81 55.97h-7.97v5.31H16.28v-5.31H8.32L0 66.5h50.12l-8.31-10.53zM16.28 43.71h17.56v10.16H42v-2.22h-1.26V3.16H42V0H7.89v3.16h1.26v48.49H7.89v2.22h8.39Zm-2.39-6.9h-2.53v-4.76a1.88 1.88 0 0 1 0-2.81v-1h2.53v1a1.89 1.89 0 0 1 .63 1.41 1.86 1.86 0 0 1-.63 1.4Z"
    />
    <path
      fill="#4ead90"
      d="M20.8 50.07h8.53v.79H20.8zM17.64 45.17h3.53v.79h-3.53zM20.8 51.89h8.53v.79H20.8zM20.8 53.71h8.53v.79H20.8z"
    />
  </svg>
)

export default Doorstep
